export default __webpack_public_path__ + "static/media/79609-loading-button.e1ad4149.gif";